import {exportedIntranetDomain, exportEnabled} from '../library/export';
import store from '../store';

export function getUsername(userId: number, type = 'user', exploded: boolean = false)
{
    const personData = store.getters.personData(userId, type);

    if (exploded)
    {
        return {
            prename: personData.prename,
            surname: personData.surname,
        };
    }

    return store.getters.personName(userId, type);
}

export function getAvatarByName(name: string, shape: string = 'circle', useIntranetColors: boolean = true, size: number = 40, asBackground: boolean = true, forceFirstChars: boolean = false)
{
    let split        = name.split(' ');
    let abbreviation = split[0].substr(0, 1);

    if (!forceFirstChars && split.length > 1)
    {
        abbreviation += split[split.length - 1].substr(0, 1);
    }
    else
    {
        abbreviation += split[0].substr(1, 1);
    }

    return getAbbreviationAvatar(abbreviation, shape, useIntranetColors, size, asBackground);
}

export function getAbbreviationAvatar(abbreviation: string, shape: string = 'circle', useIntranetColors: boolean = true, size: number = 40, asBackground: boolean = true)
{
    let urlPrefix = exportEnabled() ? exportedIntranetDomain() : '';
    let box;
    if (shape === 'circle')
    {
        box = '<circle cx="20" cy="20" r="20" stroke="none"/><circle cx="20" cy="20" r="19.5" fill="none"/>';
    }
    else
    {
        box = '<rect width="40" height="40" stroke="none"/><rect x="0.5" y="0.5" width="39" height="39" fill="none"/>';
    }

    let imageColor = '112,112,112';
    let textColor  = '#616161';

    if (useIntranetColors)
    {
        imageColor = store.state.layoutData.colors['color-primary'];
        textColor  = store.state.layoutData.colors['rgb-color-headline'];
    }

    let avatar = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 40 40">
<defs><style type="text/css">
@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: local('Roboto'), local('Roboto-Regular'), url('${urlPrefix}/fonts/Roboto/Roboto-Regular.ttf') format('truetype');
}
@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    src: local('Roboto Bold'), local('Roboto-Bold'), url('${urlPrefix}/fonts/Roboto/Roboto-Bold.ttf') format('truetype');
}</style>
</defs>
  <g fill="rgba(${imageColor},0.13)" stroke="rgba(${imageColor},0.3)" stroke-width="1">
${box}
  </g>
  <text fill="${textColor}" font-size="14" x="20" y="20" font-family="Roboto" font-weight="700" letter-spacing="0.05em" text-anchor="middle" dy=".3em">${abbreviation}</text>
</svg>`;

    if (asBackground)
    {
        return 'data:image/svg+xml;base64,' + btoa(avatar);
    }

    return avatar;
}